import React from 'react';
import { Route } from 'react-router-dom';

import PrivateRoute from 'base/PrivateRoute';

import StartPage from 'modules/User/views/StartPage';
import User from 'modules/User/views/User';
import AdminIndex from 'modules/Admin/views/AdminIndex';
import StudentListView from 'modules/Admin/views/StudentListView';
import EventView from 'modules/Admin/views/EventView';
import ManageStudentsView from 'modules/Admin/views/ManageStudentsView';
import LoginPage from 'base/views/LoginPage';
import Logout from 'base/views/Logout';

import appUrls from 'base/urls';
import AddExcelView from 'modules/Admin/views/AddExcelView';
import RoomsAuthorization from 'modules/User/views/RoomsAuthorization';
import RoomsAdminView from 'modules/Admin/views/RoomsAdminView';

export default function getRoutes() {
    const routes = [
        <Route exact path={appUrls.INDEX} component={StartPage} />,
        <Route exact path={appUrls.ENTRY_FORM} component={User} />,
        <Route exact path={appUrls.LOGIN} component={LoginPage} />,
        <Route exact path={appUrls.LOGOUT} component={Logout} />,
        <Route exact path={appUrls.ROOMS} component={RoomsAuthorization} />,
        <PrivateRoute exact path={appUrls.ADMIN_PANEL} component={AdminIndex} />,
        <PrivateRoute exact path={appUrls.STUDENT_LIST} component={ManageStudentsView} />,
        // <PrivateRoute exact path="/manage" component={ManageStudentsView} />,
        <PrivateRoute exact path={appUrls.EVENT_MANAGER} component={EventView} />,
        <PrivateRoute exact path={appUrls.EXCEL_ADD} component={AddExcelView} />,
        <PrivateRoute exact path={appUrls.ADD_ROOM} component={RoomsAdminView} />
    ];

    return routes.map((route, i) => React.cloneElement(route, { key: i }));
}


// WEBPACK FOOTER //
// ./src/base/routes.js